/* Vertical thumbnail rail.
   Dawn's own thumbnail slider buttons are tied to the media COUNT
   (<=4 images gets `large-up-hide`, which is display:none !important) and its
   slider JS scrolls horizontally. Neither matches a vertical rail that must
   show an arrow whenever the rail actually OVERFLOWS. So we inject our own. */
(function () {
  var ARROW =
    '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" ' +
    'd="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"/>' +
    '</svg>';

  function setup(gallery) {
    if (gallery.dataset.aelooRail === '1') return;
    if (gallery.getAttribute('data-desktop-layout') !== 'thumbnail') return;
    var rail = gallery.querySelector('.thumbnail-slider');
    var list = gallery.querySelector('.thumbnail-list');
    if (!rail || !list) return;
    gallery.dataset.aelooRail = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aeloo-rail-arrow';
    btn.setAttribute('aria-label', 'Show more images');
    btn.innerHTML = ARROW;
    rail.appendChild(btn);

    function update() {
      var overflows = list.scrollHeight - list.clientHeight > 2;
      var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
      gallery.classList.toggle('aeloo-rail-overflow', overflows);
      gallery.classList.toggle('aeloo-rail-end', overflows && atEnd);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      list.scrollBy({ top: list.clientHeight * 0.8, behavior: 'smooth' });
    });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(update);
      ro.observe(list);
      ro.observe(gallery);
    }
    update();
    setTimeout(update, 400);
    window.addEventListener('load', update);
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
